<p>detalhe-cursos works!</p>
